import { AvatarVideoConfig, BrandKitAvatar, ReferenceMediaFile, ScriptAngle } from 'types'
import { AvatarScriptSettings } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/NewPostModal/ScriptSettingsModal'

const ANGLES: ScriptAngle[] = ['testimonial', 'recommendation', 'product_reaction']

export interface AvatarRegenerationParams {
  avatar_id?: number
  avatar_angle?: ScriptAngle
  avatar_script?: string
  avatar_captions?: boolean
  avatar_caption_style?: string
}

export const avatarParamsFromSettings = (settings: AvatarScriptSettings): AvatarRegenerationParams => ({
  ...(settings.avatar ? { avatar_id: settings.avatar.id } : {}),
  avatar_angle: settings.avatarAngle,
  avatar_script: settings.avatarScript,
  avatar_captions: settings.avatarCaptions,
  ...(settings.avatarCaptionStyle ? { avatar_caption_style: settings.avatarCaptionStyle } : {}),
})

const promptReferenceUrl = (prompt: Record<string, unknown> | null | undefined): string | null => {
  if (typeof prompt?.reference_image_url === 'string' && prompt.reference_image_url) {
    return prompt.reference_image_url
  }
  const urls = prompt?.reference_urls
  if (Array.isArray(urls) && typeof urls[0] === 'string' && urls[0]) return urls[0]
  return null
}

const carriedProductImage = (referenceUrl: string | null): ReferenceMediaFile | null => {
  if (!referenceUrl) return null
  return { id: '', key: '', url: referenceUrl, source_url: referenceUrl, thumbnail_url: referenceUrl }
}

export const avatarSettingsFromPrompt = (
  promptOrConfig: AvatarVideoConfig | Record<string, unknown> | null | undefined,
  avatars: BrandKitAvatar[],
  fallbackCaptionStyle?: string | null,
): AvatarScriptSettings => {
  // Accept either a raw request prompt (design regen) or the resolved
  // AvatarVideoConfig served on calendar rows (batch regen); read defensively.
  const prompt = promptOrConfig as Record<string, unknown> | null | undefined
  const angle = prompt?.avatar_angle as ScriptAngle
  const resolvedAngle = ANGLES.includes(angle) ? angle : 'testimonial'
  return {
    avatar: avatars.find((a) => a.id === prompt?.avatar_id) ?? null,
    avatarAngle: resolvedAngle,
    avatarScript: typeof prompt?.avatar_script === 'string' ? prompt.avatar_script : '',
    avatarCaptions: typeof prompt?.avatar_captions === 'boolean' ? prompt.avatar_captions : true,
    avatarCaptionStyle:
      typeof prompt?.avatar_caption_style === 'string' ? prompt.avatar_caption_style : fallbackCaptionStyle ?? null,
    videoVoiceoverVoice: null,
    productImage: resolvedAngle === 'product_reaction' ? carriedProductImage(promptReferenceUrl(prompt)) : null,
  }
}
